import React from 'react';

const Support: React.FC = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Poppins:wght@300;400;500;600&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .support-root {
          font-family: 'Poppins', sans-serif;
          background: #FDF6EE;
          color: #3a1a14;
          min-height: 100vh;
          overflow-x: hidden;
        }

        .support-hero {
          background: #1a0a08;
          position: relative;
          overflow: hidden;
          padding: 64px 24px 80px;
          text-align: center;
        }

        .support-hero::before {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(ellipse 80% 60% at 50% 0%, rgba(239,49,34,0.35) 0%, transparent 70%);
          pointer-events: none;
        }

        .support-hero-blob {
          position: absolute;
          width: 420px; height: 420px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(239,49,34,0.15), transparent 70%);
          bottom: -140px; right: -100px;
          pointer-events: none;
        }

        .support-logo {
          display: inline-flex;
          align-items: center; justify-content: center;
          width: 88px; height: 88px;
          border-radius: 22px;
          background: white;
          box-shadow: 0 8px 40px rgba(239,49,34,0.45);
          margin-bottom: 28px;
          animation: supportPopIn 0.7s cubic-bezier(.22,1.4,.64,1) both;
        }

        .support-logo svg { width: 52px; height: 52px; fill: #fff; }

        .support-hero h1 {
          font-family: 'Bebas Neue', sans-serif;
          font-size: clamp(3rem, 10vw, 5.5rem);
          font-weight: 400;
          color: #fff;
          line-height: 1;
          letter-spacing: 0.04em;
          animation: supportFadeUp 0.7s 0.15s both;
        }

        .support-hero h1 span { color: #ff6b5b; }

        .support-hero p {
          margin-top: 16px;
          font-size: 1rem;
          color: rgba(255,255,255,0.55);
          font-weight: 300;
          max-width: 400px;
          margin-inline: auto;
          line-height: 1.6;
          animation: supportFadeUp 0.7s 0.25s both;
        }

        .support-badge {
          display: inline-block;
          margin-top: 24px;
          background: rgba(239,49,34,0.18);
          border: 1px solid rgba(239,49,34,0.4);
          color: #ff6b5b;
          font-size: 0.75rem;
          font-weight: 500;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          padding: 6px 18px;
          border-radius: 100px;
          animation: supportFadeUp 0.7s 0.35s both;
        }

        @keyframes supportPopIn {
          from { transform: scale(0.6); opacity: 0; }
          to   { transform: scale(1);   opacity: 1; }
        }

        @keyframes supportFadeUp {
          from { transform: translateY(20px); opacity: 0; }
          to   { transform: translateY(0);    opacity: 1; }
        }

        main {
          padding: 60px 24px 80px;
        }

        .section-label {
          font-size: 0.72rem;
          font-weight: 500;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: var(--red);
          margin-bottom: 20px;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 14px;
          margin-bottom: 56px;
        }

        @media (max-width: 480px) {
          .contact-grid { grid-template-columns: 1fr; }
        }

        .card {
          display: flex;
          align-items: center;
          gap: 14px;
          background: #fff;
          border: 1.5px solid rgba(239,49,34,0.1);
          border-radius: 16px;
          padding: 18px 20px;
          text-decoration: none;
          color: var(--text);
          transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
          position: relative;
          overflow: hidden;
        }

        .card::after {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(239,49,34,0.06), transparent);
          opacity: 0;
          transition: opacity 0.2s;
        }

        .card:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 32px rgba(239,49,34,0.12);
          border-color: rgba(239,49,34,0.35);
        }

        .card:hover::after { opacity: 1; }

        .card-icon {
          width: 44px; height: 44px;
          border-radius: 12px;
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0;
          font-size: 22px;
        }

        .card-icon.wa  { background: #e8f8ef; }
        .card-icon.em  { background: #fff0ee; }
        .card-icon.ig  { background: #fef0f8; }
        .card-icon.fb  { background: #eef2ff; }
        .card-icon.ph  { background: #fff8ee; }

        .card-info { min-width: 0; }
        .card-info strong {
          display: block;
          font-size: 0.82rem;
          font-weight: 500;
          color: var(--muted);
          margin-bottom: 2px;
        }
        .card-info span {
          font-size: 0.9rem;
          font-weight: 500;
          color: var(--text);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
        }

        .arrow {
          margin-left: auto;
          color: var(--red);
          font-size: 1.1rem;
          flex-shrink: 0;
          opacity: 0.5;
          transition: opacity 0.2s, transform 0.2s;
        }
        .card:hover .arrow { opacity: 1; transform: translateX(3px); }

        .faq-title {
          font-family: 'Bebas Neue', sans-serif;
          font-size: 2.4rem;
          font-weight: 400;
          letter-spacing: 0.05em;
          color: var(--dark);
          margin-bottom: 24px;
        }

        .faq-list { display: flex; flex-direction: column; gap: 12px; margin-bottom: 56px; }

        details {
          background: #fff;
          border: 1.5px solid rgba(239,49,34,0.1);
          border-radius: 14px;
          overflow: hidden;
          transition: box-shadow 0.2s;
        }

        details[open] {
          box-shadow: 0 6px 24px rgba(239,49,34,0.08);
          border-color: rgba(239,49,34,0.25);
        }

        summary {
          padding: 18px 20px;
          font-size: 0.97rem;
          font-weight: 500;
          cursor: pointer;
          list-style: none;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: var(--dark);
          user-select: none;
        }
        summary::-webkit-details-marker { display: none; }

        .chevron {
          width: 20px; height: 20px;
          color: var(--red);
          transition: transform 0.25s;
          flex-shrink: 0;
        }
        details[open] .chevron { transform: rotate(180deg); }

        .faq-body {
          padding: 0 20px 18px;
          font-size: 0.92rem;
          color: var(--muted);
          line-height: 1.7;
          border-top: 1px solid rgba(239,49,34,0.07);
          margin-top: 0;
          padding-top: 14px;
        }

        footer {
          background: var(--dark);
          text-align: center;
          padding: 36px 24px;
          color: rgba(255,255,255,0.35);
          font-size: 0.82rem;
        }
        footer span { color: var(--red-light); }
      `}</style>

      <div className="support-root">
        <div className="support-hero">
          <div className="support-hero-blob"></div>

          <div className="support-logo">
            <img src="logo.png" alt="Varag Vardan" style={{width: '100%', height: '100%', objectFit: 'contain'}} />
          </div>
          <h1>Varag <span>Vardan</span></h1>
          <p>Gwadar's first grocery delivery app — fresh essentials, right to your door.</p>
          <div className="support-badge">Support Center</div>
        </div>

      <main>
        <p className="section-label">Get in Touch</p>
        <div className="contact-grid">
          <a className="card" href="https://wa.me/923218628554" target="_blank" rel="noopener noreferrer">
            <div className="card-icon wa">📱</div>
            <div className="card-info">
              <strong>WhatsApp</strong>
              <span>+92 321 8628554</span>
            </div>
            <span className="arrow">→</span>
          </a>

          <a className="card" href="mailto:varagovardan@gmail.com">
            <div className="card-icon em">✉️</div>
            <div className="card-info">
              <strong>Email</strong>
              <span>varagovardan@gmail.com</span>
            </div>
            <span className="arrow">→</span>
          </a>

          <a className="card" href="https://instagram.com/varagvardan" target="_blank" rel="noopener noreferrer">
            <div className="card-icon ig">📸</div>
            <div className="card-info">
              <strong>Instagram</strong>
              <span>@varagvardan</span>
            </div>
            <span className="arrow">→</span>
          </a>

          <a className="card" href="https://www.facebook.com/people/Varag-Vardan/" target="_blank" rel="noopener noreferrer">
            <div className="card-icon fb">👥</div>
            <div className="card-info">
              <strong>Facebook</strong>
              <span>Varag Vardan</span>
            </div>
            <span className="arrow">→</span>
          </a>

          <a className="card" href="tel:+923218628554">
            <div className="card-icon ph">📞</div>
            <div className="card-info">
              <strong>Phone</strong>
              <span>+92 321 8628554</span>
            </div>
            <span className="arrow">→</span>
          </a>
        </div>

        <p className="section-label">Frequently Asked Questions</p>
        <h2 className="faq-title">How can we help?</h2>

        <div className="faq-list">
          <details>
            <summary>
              Where do you deliver?
              <svg className="chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="6 9 12 15 18 9"/></svg>
            </summary>
            <p className="faq-body">We currently deliver across Gwadar city. We are the first grocery delivery app serving Gwadar and plan to expand soon.</p>
          </details>

          <details>
            <summary>
              How do I place an order?
              <svg className="chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="6 9 12 15 18 9"/></svg>
            </summary>
            <p className="faq-body">Download the Varag Vardan app, browse products, add items to your cart, and place your order.</p>
          </details>

          <details>
            <summary>
              How long does delivery take?
              <svg className="chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="6 9 12 15 18 9"/></svg>
            </summary>
            <p className="faq-body">Delivery times vary by location and order size. You can track your order status live within the app after placing your order.</p>
          </details>

          <details>
            <summary>
              Can I cancel or modify my order?
              <svg className="chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="6 9 12 15 18 9"/></svg>
            </summary>
            <p className="faq-body">Yes, you can cancel the order in the app within the first 5 minutes. To cancel or modify an order after that, please contact us immediately via WhatsApp or phone. We will do our best to accommodate changes before your order is dispatched.</p>
          </details>

          <details>
            <summary>
              What if I receive a wrong or damaged item?
              <svg className="chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="6 9 12 15 18 9"/></svg>
            </summary>
            <p className="faq-body">We're sorry to hear that! Please contact us on WhatsApp or email with a photo of the item within 24 hours of delivery and we will resolve it promptly.</p>
          </details>

          <details>
            <summary>
              How do I report a technical issue with the app?
              <svg className="chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="6 9 12 15 18 9"/></svg>
            </summary>
            <p className="faq-body">Please email us at varagovardan@gmail.com or message us on WhatsApp describing the issue. Screenshots are helpful so we can fix it as quickly as possible.</p>
          </details>
        </div>
      </main>
      </div>
    </>
  );
};

export default Support;
